/* eslint-disable @typescript-eslint/no-unused-vars */
import { RESET_STATE, SET_IS_LOADING, SET_USER_AGENT } from './constant'
import { ActionTree } from 'vuex'
import { AppState, ResetStatePayload } from './types'
import { resetState } from '@/store/api/authentication'

export const actions: ActionTree<AppState, any> = {
  [RESET_STATE]({ commit }, payload: ResetStatePayload) {
    return resetState(payload)
  },
  [SET_IS_LOADING]({ commit }, isLoading: boolean) {
    commit(SET_IS_LOADING, isLoading)
  },
  [SET_USER_AGENT]({ commit }) {
    const result = navigator.userAgent.match(/\w+/)
    if (result) {
      commit(SET_USER_AGENT, result[0].toLowerCase())
    }
  }
}
